import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { PerlaLogo } from "@/components/site/PerlaLogo";

const formatErr = (detail) => {
  if (!detail) return "Errore imprevisto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};

export default function CRMLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) nav("/crm", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Benvenuto");
      nav("/crm", { replace: true });
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-5" data-testid="crm-login-page">
      <div className="absolute top-6 left-6">
        <Link to="/" className="text-[#FAFAF7]/50 hover:text-[#FF5A1F] flex items-center gap-2 text-xs uppercase tracking-widest">
          <ArrowLeft size={14} /> Torna al sito
        </Link>
      </div>
      <div className="w-full max-w-md bg-[#1A1A1A] border border-[#2A2A2A] p-8">
        <div className="mb-8">
          <PerlaLogo light />
          <div className="mt-3 text-[10px] uppercase tracking-widest text-[#FF5A1F] font-bold">CRM · Accesso</div>
          <p className="mt-3 text-sm text-[#FAFAF7]/60">Admin, Venditori, Outreach e Artisti.</p>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="crm-login-form">
          <label className="block">
            <span className="text-[10px] uppercase tracking-widest text-[#FAFAF7]/50 font-bold">Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus data-testid="crm-login-email"
              className="mt-2 block w-full bg-[#0A0A0A] border-2 border-[#3A3A3A] py-3 px-4 text-[#FAFAF7] focus:outline-none focus:border-[#FF5A1F]" />
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-widest text-[#FAFAF7]/50 font-bold">Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="crm-login-password"
              className="mt-2 block w-full bg-[#0A0A0A] border-2 border-[#3A3A3A] py-3 px-4 text-[#FAFAF7] focus:outline-none focus:border-[#FF5A1F]" />
          </label>
          <button type="submit" disabled={busy} className="btn-cta w-full disabled:opacity-60" data-testid="crm-login-submit">
            <LogIn size={16} /> {busy ? "..." : "Accedi al CRM"}
          </button>
        </form>
      </div>
    </div>
  );
}
